import type {
  ParsedSurveyCsvFlattenedAnswerValue,
  SurveyAnswerFlattenedRecord,
  SurveyAnswerRecord,
  SurveyElementJson,
} from '../types'
import { parseAnswer, parseCommentAnswer, parseOtherAnswer } from './answer.util'
import { hasShowCommentArea, hasShowOtherItem } from './question.util'

/**
 * パネル要素の回答データを平坦化する
 */
export function flattenPanelAnswers(surveyAnswer: SurveyAnswerRecord): SurveyAnswerFlattenedRecord {
  const result: SurveyAnswerFlattenedRecord = {}

  for (const [key, value] of Object.entries(surveyAnswer)) {
    if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
      // パネル要素の場合、その中の要素を平坦化
      Object.assign(result, value)
    } else {
      // 通常の要素の場合、そのまま追加
      result[key] = value
    }
  }

  return result
}

/**
 * 質問IDと回答のMapを作成する
 */
export function makeQuestionIdFlattenedAnswerMap(questions: SurveyElementJson[], surveyAnswer: SurveyAnswerFlattenedRecord): Record<string, ParsedSurveyCsvFlattenedAnswerValue> {
  const answerMap: Record<string, ParsedSurveyCsvFlattenedAnswerValue> = {}

  // パネル要素内の設問を含む、全ての設問を展開
  const allQuestions = questions.flatMap(question =>
    question.type === 'panel' && question.elements ? question.elements : [question],
  )

  for (const question of allQuestions) {
    const parsedAnswer = parseAnswer(question, surveyAnswer)
    if (parsedAnswer !== undefined) {
      answerMap[question.name] = parsedAnswer
    }

    if (hasShowOtherItem(question)) {
      const parsedAnswer = parseOtherAnswer(question, surveyAnswer)
      if (parsedAnswer !== undefined) {
        answerMap[`${question.name}_other`] = parsedAnswer
      }
    }

    if (hasShowCommentArea(question)) {
      const parsedAnswer = parseCommentAnswer(question, surveyAnswer)
      if (parsedAnswer !== undefined) {
        answerMap[`${question.name}_comment`] = parsedAnswer
      }
    }
  }

  return answerMap
}

/**
 * 質問IDから質問内容と回答を取得する
 */
export function findOneAnswer(questionId: string, questions: SurveyElementJson[], surveyAnswer: any) {
  for (const question of questions) {
    if (question.name === questionId) {
      const parsedAnswer = parseAnswer(question, surveyAnswer)
      return {
        type: question.type,
        title: question.title,
        answer: parsedAnswer,
      }
    }
  }
  return undefined
}
